import React, {useRef, useState} from 'react';
import styled from 'styled-components';
import { Table } from 'ui-kit/Table';
import { PaginatorPageChangeEvent } from 'primereact/paginator';
import { Toast } from 'primereact/toast';
import { Release } from 'types/release';
import { getColumns } from './columns';
import {FormattedMessage} from "react-intl";
import IntlStore from "stories/IntlStore";

interface ReleaseProps {
  count: number;
  releases: Release[];
  currentPage: number;
  pageCount: number;
  onPageChange: (event: PaginatorPageChangeEvent) => void;
}

export const Releases: React.FC<ReleaseProps> = props => {
  const { count, releases, currentPage, pageCount, onPageChange } = props;
  const columns = getColumns(() => {
    toast.current?.show({
      severity: 'success',
      summary: IntlStore.intl.formatMessage({
        id: "Labels.Success",
        defaultMessage: "Success"
      }),
      detail: IntlStore.intl.formatMessage({
        id: "Labels.EANCopiedSuccessfully",
        defaultMessage: "EAN copied successfully"
      }),
    });
  });
  const toast = useRef<any>(null);
  return (
    <Container>
      <Title>
        <FormattedMessage
          id="Labels.Releases.Title"
          defaultMessage="{count} releases"
          values={{count}}
        />
      </Title>
      <Table
        total={count}
        pageCount={pageCount}
        currentPage={currentPage}
        columns={columns}
        data={releases}
        onPageChange={onPageChange}
      />
      <Toast ref={toast} />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  border-radius: 30px;
  background-color: #ffffff;
  padding: 20px;
  flex: 1;
  overflow-y: auto;

  .p-row-odd{
    background-color: #E9E9E9;
  }
`;

const Title = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
`;
